import { route } from "@circle-react/lib/routes/define";

export const paywallRoutes = {
  onboarding: route("/settings/paywalls/onboarding", {
    title: "Connect Stripe",
    requires: "admin",
    description: "Stripe Connect embedded onboarding.",
  }),

  list: route("/settings/paywalls", {
    title: "Paywalls",
    requires: "admin",
    description: "Lists all paywalls in the community's settings area.",
  }),

  new: route("/settings/paywalls/new", {
    title: "Create paywall",
    requires: "admin",
    description: "Form to create a new paywall.",
  }),

  edit: route("/settings/paywalls/:id/edit", {
    title: "Edit paywall",
    requires: "admin",
    description: "Edit form for a specific paywall.",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric identifier of the paywall to edit.",
      },
    },
  }),

  editCheckoutCustomization: route(
    "/settings/paywalls/:id/edit/checkout/customization",
    {
      title: "Customize checkout page",
      requires: "admin",
      description:
        "Visual editor for a paywall's main checkout page appearance — hero section, " +
        "badges, benefits, testimonials, countdown timer, price callouts, and reduced-price " +
        "display. This is the checkout-page customization surface, distinct from the upsell " +
        "offer customization surface at the upsell/customization route.",
      pathParams: {
        id: {
          type: "number",
          description:
            "Numeric identifier of the paywall whose checkout page is being customized.",
        },
      },
    },
  ),

  editUpsellCustomization: route(
    "/settings/paywalls/:id/edit/upsell/customization",
    {
      title: "Customize upsell offer",
      requires: "admin",
      description:
        "Visual editor for a paywall's upsell offer appearance — hero section, badges, " +
        "benefits, testimonials, media blocks, countdown timer, and price callouts. Scoped " +
        "to the paywall; the specific offer being edited is selected within the screen, so " +
        "this route only takes the paywall id. Distinct from the main checkout-page " +
        "customization surface at the checkout/customization route.",
      pathParams: {
        id: {
          type: "number",
          description:
            "Numeric identifier of the paywall whose upsell offer is being customized.",
        },
      },
    },
  ),
  paymentSettings: route("/settings/paywall_payment_settings", {
    title: "Paywall payment settings",
    requires: "admin",
    description:
      "Manage payment method settings for paywalls (Apple Pay, Klarna, SEPA Debit, etc.).",
  }),

  taxSettings: route("/settings/paywall_tax_settings", {
    title: "Paywall tax settings",
    requires: "admin",
    description:
      "Manage tax settings for paywalls (tax collection, tax ID, and tax-inclusive pricing).",
  }),
};
